import { CarouselSchemeDefinition } from "./carousel-types";
import { BackgroundColor } from "../../background/constants/background-types";

import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createCarouselMapDefinition } from "../../../utils/scheme-helper";

export const INDICATORSIZE_SMALL = "small";
export const INDICATORSIZE_LARGE = "large";

export const INDICATOR_SIZES = [INDICATORSIZE_SMALL, INDICATORSIZE_LARGE] as const;

export const INDICATORPOSITION_LEFT = "left";
export const INDICATORPOSITION_CENTER = "center";
export const INDICATORPOSITION_RIGHT = "right";

export const INDICATOR_POSITIONS = [INDICATORPOSITION_LEFT, INDICATORPOSITION_CENTER, INDICATORPOSITION_RIGHT] as const;

export const CONTROL_STYLE_DEFAULT = "default";
export const CONTROL_STYLE_OUTSIDE = "outside";

export const CONTROL_STYLE = [CONTROL_STYLE_DEFAULT, CONTROL_STYLE_OUTSIDE] as const;

function createSchemes() {
  let newSchemes: AllColors.CarouselSchemeConfiguration<CarouselSchemeDefinition> = {};
  AllColors.CAROUSEL_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      indicatorColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      indicatorHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      indicatorActColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      controlColorBright: AllColors[`COLOR_BRIGHT_OPACITY_60`],
      controlIconColorBright: AllColors[`COLOR_BRIGHT`],
      controlColorDark: AllColors[`COLOR_DARK_OPACITY_30`],
      controlIconColorDark: AllColors[`COLOR_BRIGHT`],
      controlHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      controlHoverIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      outsideControlColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      outsideControlIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      outsideControlHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      outsideControlHoverIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const CAROUSEL_SCHEME_CONFIG: AllColors.CarouselSchemeConfiguration<CarouselSchemeDefinition> = createSchemes();

export const CAROUSEL_SCHEME_MAP: Map<BackgroundColor | "default", CarouselSchemeDefinition> = new Map(
  Object.entries(createCarouselMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    CAROUSEL_SCHEME_CONFIG[config as string]
  ])
);
